/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { EffectCreative } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo, dragging } from '../asset'
import CIIcon from './CIIcon'

function RotateCirclePreview({
  srcs,
  correspondImgs,
  isReset,
  redirectUrl,
  correspondVideos,
}) {
  const [currentCorrespondIndex, setCurrentCorrespondIndex] = useState(0)
  const [imageUrls, setImageUrls] = useState([])
  const [correspondImageUrls, setCorrespondImageUrls] = useState([])
  const [isVisible, setIsVisible] = useState(true)
  const swiperRef = useRef(null)
  const [swiperHeight, setSwiperHeight] = useState('auto')
  const [hasSwiped, setHasSwiped] = useState(false)
  const isSwiperInitialized = useRef(false)
  const [showCorrespondImg, setShowCorrespondImg] = useState(true)
  const secondSwiperRef = useRef(null)
  const lastIndexRef = useRef(0)
  const [isMuted, setIsMuted] = useState(true)
  const videoRefs = useRef([])
  const prevIndexRef = useRef(0)

  const autoplayTimer = useRef(null)

  const scheduleNextSlide = (swiper, index) => {
    let delay = 3000

    const prevIndex = prevIndexRef.current
    const prevVideo = videoRefs.current[prevIndex]
    if (prevVideo && typeof prevVideo.pause === 'function') {
      prevVideo.pause()
      prevVideo.currentTime = 0
    }

    const videoEl = videoRefs.current[index]
    if (
      videoEl &&
      typeof videoEl.duration === 'number' &&
      !Number.isNaN(videoEl.duration)
    ) {
      delay = videoEl.duration * 1000
    }

    prevIndexRef.current = index

    if (autoplayTimer.current) {
      clearTimeout(autoplayTimer.current)
    }

    autoplayTimer.current = setTimeout(() => {
      if (swiper && typeof swiper.slideNext === 'function') {
        swiper.slideNext()
      }
    }, delay)
  }

  useEffect(() => {
    const newUrls = srcs.map((img) =>
      img.file instanceof File || img.file instanceof Blob
        ? URL.createObjectURL(img.file)
        : img.file
    )

    setImageUrls((prevUrls) => {
      prevUrls.forEach((url) => {
        if (
          url &&
          typeof url === 'string' &&
          url.startsWith('blob:') &&
          !newUrls.includes(url)
        ) {
          // URL.revokeObjectURL(url)
        }
      })
      return newUrls
    })

    return () => {
      newUrls.forEach((url) => {
        if (url && typeof url === 'string' && url.startsWith('blob:')) {
          // URL.revokeObjectURL(url)
        }
      })
    }
  }, [srcs])

  useEffect(() => {
    if (!Array.isArray(correspondImgs)) return

    const newUrls = correspondImgs.map((img) =>
      img?.file instanceof File || img?.file instanceof Blob
        ? {
            ...img,
            preview: URL.createObjectURL(img.file),
          }
        : img
    )

    setCorrespondImageUrls((prevUrls) => {
      prevUrls.forEach((img) => {
        if (
          img?.preview &&
          typeof img.preview === 'string' &&
          img.preview.startsWith('blob:') &&
          !newUrls.find((newImg) => newImg.preview === img.preview)
        ) {
          // URL.revokeObjectURL(img.preview)
        }
      })
      return newUrls
    })

    return () => {
      newUrls.forEach((img) => {
        if (
          img?.preview &&
          typeof img.preview === 'string' &&
          img.preview.startsWith('blob:')
        ) {
          // URL.revokeObjectURL(img.preview)
        }
      })
    }
  }, [correspondImgs])

  useEffect(() => {
    const updateSwiperHeight = () => {
      if (swiperRef.current && swiperRef.current.el) {
        const height = swiperRef.current.el.offsetHeight
        setSwiperHeight(`${height}px`)
      }
    }

    updateSwiperHeight()
    window.addEventListener('resize', updateSwiperHeight)

    return () => {
      window.removeEventListener('resize', updateSwiperHeight)
    }
  }, [imageUrls])

  useEffect(() => {
    if (isReset) {
      setIsVisible(true)
      setHasSwiped(false)
      isSwiperInitialized.current = false
    }
  }, [isReset, srcs.length])

  // useEffect(() => {
  //   let objectUrl = null

  //   if (
  //     correspondVideos &&
  //     typeof correspondVideos !== 'string' &&
  //     (correspondVideos instanceof File || correspondVideos instanceof Blob)
  //   ) {
  //     objectUrl = URL.createObjectURL(correspondVideos)
  //   }

  //   return () => {
  //     if (objectUrl) URL.revokeObjectURL(objectUrl)
  //   }
  // }, [correspondVideos])

  useEffect(
    () => () => {
      if (autoplayTimer.current) clearTimeout(autoplayTimer.current)
    },
    []
  )

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      {/* 頂部內容 */}
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {/* Swiper 1 */}
      {isVisible && (
        <div
          id="swiper-box"
          style={{
            width: '240px',
            minHeight: `${swiperHeight}px`,
            position: 'absolute',
            zIndex: '1501',
            overflow: 'visible',
            bottom: '8%',
          }}
        >
          {isVisible && !hasSwiped && (
            <Button
              onClick={() => setIsVisible(false)}
              style={{
                position: 'absolute',
                top: '-20px',
                right: '4px',
                background: 'rgba(0,0,0,0.5)',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '22px',
                height: '22px',
                fontSize: '14px',
                zIndex: 2000,
                padding: 0,
              }}
            >
              ✕
            </Button>
          )}
          <Swiper
            ref={swiperRef}
            effect="creative"
            grabCursor
            speed={300}
            modules={[EffectCreative]}
            loop
            observer
            observeParents
            className="swiper-creative swiper-slidingcovermulti"
            style={{ width: '100%', position: 'relative' }}
            creativeEffect={{
              prev: {
                translate: ['-120%', '120%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
              },
              next: {
                translate: ['120%', '-120%', 0],
                rotate: [0, 0, 30],
                opacity: 1,
                stretch: 50,
              },
              current: {
                translate: [0, 0, 0],
                rotate: [0, -90, 0],
                opacity: 1,
              },
              previous: {
                translate: ['50%', '-50%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
                stretch: 50,
              },
            }}
            onSwiper={(swiper) => {
              isSwiperInitialized.current = true
              swiperRef.current = swiper
            }}
            onSlideChangeTransitionEnd={(swiper) => {
              if (!isSwiperInitialized.current) return

              const index = swiper.realIndex
              lastIndexRef.current = index

              setHasSwiped(true)
              setShowCorrespondImg(true)
              setCurrentCorrespondIndex(index)

              if (secondSwiperRef.current) {
                const secondSwiper = secondSwiperRef.current
                const total = correspondImageUrls.length
                const current = secondSwiper.realIndex
                const target = index
                scheduleNextSlide(secondSwiper, index)

                let diff = target - current
                const half = total / 2

                if (Math.abs(diff) > half) {
                  diff = diff > 0 ? diff - total : diff + total
                }

                if (diff > 0) {
                  secondSwiper.slideNext(500)
                } else if (diff < 0) {
                  secondSwiper.slidePrev(500)
                }
              }
            }}
          >
            {imageUrls.map((image, index) => (
              <SwiperSlide
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'column-reverse',
                  alignItems: 'flex-end',
                  overflow: 'hidden',
                  width: '240px',
                  justifyContent: 'flex-end',
                }}
              >
                <a href={redirectUrl} target="_blank" rel="noopener noreferrer">
                  <img
                    src={image}
                    alt={`Slide ${index}`}
                    style={{
                      width: '99%',
                      height: 'auto',
                      objectFit: 'contain',
                      marginTop: 'auto',
                    }}
                  />
                </a>
                <CIIcon />
              </SwiperSlide>
            ))}
          </Swiper>
          <img
            src={dragging}
            alt="Drag Hint"
            style={{
              position: 'absolute',
              bottom: '90%',
              left: '15px',
              width: '40px',
              height: 'auto',
              zIndex: '9999',
              animation: 'dragHintLeftRight 1.8s ease-in-out infinite',
              pointerEvents: 'none',
              opacity: 0.75,
              backgroundColor: 'rgba(255,255,255,0.8)',
              borderRadius: '50%',
              cursor: 'grab',
            }}
          />
        </div>
      )}

      {hasSwiped && showCorrespondImg && correspondImageUrls.length > 0 && (
        <div
          className="position-absolute"
          style={{
            bottom: '28%',
            width: '100%',
            maxWidth: '190px',
            right: '21%',
          }}
        >
          {/* Swiper 2 */}
          <Swiper
            ref={secondSwiperRef}
            onBeforeInit={(instance) => {
              const swiperParams = instance.params
              swiperParams.loopedSlides = Math.max(
                correspondImageUrls.length,
                5
              )
              console.log('loopedSlides set to:', swiperParams.loopedSlides)
            }}
            effect="creative"
            grabCursor
            speed={500}
            modules={[EffectCreative]}
            loop
            observer
            observeParents
            initialSlide={currentCorrespondIndex}
            onSwiper={(swiper) => {
              secondSwiperRef.current = swiper
            }}
            onSlideChange={(swiper) => {
              const index = swiper.realIndex
              setCurrentCorrespondIndex(index)
              if (swiperRef.current?.slideToLoop) {
                swiperRef.current.slideToLoop(index)
              }
              scheduleNextSlide(swiper, index)
            }}
            creativeEffect={{
              prev: {
                translate: ['-120%', '120%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
              },
              next: {
                translate: ['120%', '-120%', 0],
                rotate: [0, 0, 30],
                opacity: 1,
                stretch: 50,
              },
              current: {
                translate: [0, 0, 0],
                rotate: [0, -90, 0],
                opacity: 1,
              },
              previous: {
                translate: ['50%', '-50%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
                stretch: 50,
              },
            }}
          >
            {correspondImageUrls.map((img, i) => {
              const videoFile = correspondVideos?.[i]?.file
              let videoURL = ''
              if (videoFile instanceof File || videoFile instanceof Blob) {
                videoURL = URL.createObjectURL(videoFile)
              } else if (typeof videoFile === 'string') {
                videoURL = videoFile
              }

              return (
                <SwiperSlide key={i}>
                  <div className="position-relative w-100">
                    {videoURL && (
                      <>
                        <video
                          preload="metadata"
                          ref={(el) => {
                            videoRefs.current[i] = el
                          }}
                          src={videoURL}
                          autoPlay
                          muted={isMuted}
                          loop
                          playsInline
                          className="video-fade-in"
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                            zIndex: 1000,
                          }}
                        >
                          <track kind="captions" srcLang="en" src="" default />
                        </video>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation()
                            setIsMuted((prev) => {
                              const newMuted = !prev
                              const videoEl = videoRefs.current[i]
                              if (videoEl) videoEl.muted = newMuted
                              return newMuted
                            })
                          }}
                          style={{
                            position: 'absolute',
                            left: '5px',
                            top: '25%',
                            zIndex: 1500,
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            borderRadius: '50%',
                            width: '28px',
                            height: '28px',
                            color: 'white',
                            fontSize: '14px',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          <FontAwesomeIcon
                            icon={isMuted ? faVolumeXmark : faVolumeHigh}
                          />
                        </button>
                      </>
                    )}

                    <a
                      href={redirectUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={img.preview}
                        alt={`Corresponding ${i}`}
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block',
                        }}
                      />
                    </a>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
          <Button
            variant="light"
            size="sm"
            className="position-absolute"
            style={{
              top: '-30px',
              right: '-10px',
              zIndex: 1001,
              height: '25px',
              width: '25px',
              backgroundColor: 'rgb(17 17 17 / 50%)',
              borderRadius: '50%',
              border: 'none',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
            }}
            onClick={() => {
              setShowCorrespondImg(false)
              setTimeout(() => setHasSwiped(false), 200)
            }}
          >
            ✕
          </Button>
        </div>
      )}

      {/* 底部內容 */}
      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

RotateCirclePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ).isRequired,
  correspondImgs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      preview: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ),
  isReset: PropTypes.bool,
  redirectUrl: PropTypes.string,
  correspondVideos: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ),
}

RotateCirclePreview.defaultProps = {
  correspondImgs: [],
  isReset: false,
  redirectUrl: '',
  correspondVideos: [],
}

export default RotateCirclePreview
